import { CONSTANTS } from "consts";

export const MEMBERSHIP_TYPES = {
  MONTHLY: "monthly",
  YEARLY: "yearly",
} as const;

export const MEMBERSHIP_CURRENCY = {
  USD: "usd",
  CAD: "cad",
} as const;




export const handleCheckIsWarrantyMembership = (type: string) => {
    return type === "membership-with-warranty";
};

export const handleCheckIsUpgradeMembership = (maxMachine: number) => {
    return maxMachine > 1;
}


export const handleCheckIsAnnualMembership = (type: string) => {
  return type === MEMBERSHIP_TYPES.YEARLY;
};

export const handleCheckIsMonthlyMembership = (type: string) => {
  return type === MEMBERSHIP_TYPES.MONTHLY;
};

export const handleCheckIsUSDCurrency = (type: string) => {
    return type === MEMBERSHIP_CURRENCY.USD;
};

export const handleCheckIsCADCurrency = (type: string) => {
  return type === MEMBERSHIP_CURRENCY.CAD;
};

export const handleCheckIsGoMembership = (appIds: number[]) => {
  return appIds?.includes(CONSTANTS.APP.AVIRON_GO);
};

